import { UIMessage } from "ai";

const PAYMENT_REFERENCE_PART_TYPE = "data-paymentReference";

export const buildPaymentReferencePart = (transactionId: string) =>
  ({ type: PAYMENT_REFERENCE_PART_TYPE, data: { transactionId } }) as const;

export const getReferencedPaymentId = (message: UIMessage | undefined): string | null => {
  const part = message?.parts.find((candidate) => candidate.type === PAYMENT_REFERENCE_PART_TYPE);
  const transactionId =
    part && "data" in part ? (part.data as { transactionId?: unknown } | null)?.transactionId : null;
  return typeof transactionId === "string" ? transactionId : null;
};
